export default function (instance) {
    return {
        getUser(payload){
            return instance.get('user', payload)
        },
        createUser(payload){
            return instance.postForm('user', payload)
        },
        optionsClub(payload){
            return instance.options('club', payload)
        },
        changeCurrentClub(id){
            return instance.postForm('user/current-club', {club: id})
        },
    }
}